var codeblock_default = {
  "blockStyleSpacing": "sKXki",
  "codeBlock": "D43cj sKXki",
  "renderedInTable": "_4A3t1"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
